import { z } from 'zod'

export const forgotPasswordFormSchema = z.object({
  email: z.string().min(1, 'auth:errors.emailRequired').email('auth:errors.invalidEmail'),
})

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordFormSchema>

export const defaultForgotPasswordValues: ForgotPasswordFormValues = {
  email: '',
}
